import styled, { css } from "styled-components";
import MarkerSvg from "assets/images/svg/lightning.svg";

export const TextWithListContainer = styled.div`
  color: inherit;
  max-width: 780px;

  font-size: 24px;
  line-height: 32px;
  font-family: "Mona-Sans";
  font-weight: 400;
  font-size: 20px;
  line-height: 150%;
  letter-spacing: 0px;
  vertical-align: middle;

  margin-bottom: 100px;
  margin-left: auto;

  ${(props) =>
    props?.$twoColumns &&
    css`
      max-width: none;
      width: 100%;
      margin-left: 0;
      margin-right: 0;
    `}

  ${(props) =>
    !props?.$textAlignRight &&
    css`
      margin-left: 0;
    `}

  @media (max-width: 600px) {
    font-size: 16px;
    margin-top: 20px;
  }
`;

export const List = styled.ul`
  margin-top: 32px;

  ${(props) =>
    props.$twoColumns &&
    css`
      column-count: 2;
      column-gap: 64px;
      width: 100%;
      padding-left: 0;
      
      @media (max-width: 600px) {
        column-count: 1;
        column-gap: 0;
      }
    `}

  @media (max-width: 600px) {
    padding-inline-start: 0;
  }
`;
export const ListItem = styled.li`
  list-style: none;
  padding-left: 55px;
  position: relative;
  display: flex;
  align-items: flex-start;
  margin-bottom: 32px;
  break-inside: avoid;

  &::before {
    content: "";
    display: inline-block;
    width: 30px;
    height: 40px;
    background-image: url(${MarkerSvg});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center top;
    position: absolute;
    left: 0;
    top: 0;
  }

  @media (max-width: 600px) {
    padding-left: 40px;
    margin-bottom: 24px;

    &::before {
      width: 25px;
      height: 32px;
    }
  }
`;
